import 'hammerjs';
import 'moment/min/locales';

import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@michelin/auth';
import { URL } from '../environments/environment';
import { AppRoutingModule } from './app.routing';
import { ApplicationComponent } from './application/application.component';
import { ConfigurationDbModalComponent } from './application/configuration-db-modal/configuration-db-modal.component';
import { ConfigurationDbComponent } from './application/configuration-db/configuration-db.component';
import { ControllerModalComponent } from './application/controller-modal/controller-modal.component';
import { GroupModalComponent } from './application/group-modal/group-modal.component';
import { GroupElementComponent } from './application/group/group-element/group-element.component';
import { GroupComponent } from './application/group/group.component';
import { ImportFileModalComponent } from './application/import-file-modal/import-file-modal.component';
import { ImportFileXlsxModalComponent } from './application/import-file-xlsx-modal/import-file-xlsx-modal.component';
import { HistoricXlsxModalComponent } from './application/import-file-xlsx/historic-xlsx-modal/historic-xlsx-modal.component';
import { ImportFileXlsxComponent } from './application/import-file-xlsx/import-file-xlsx.component';
import { HistoricModalComponent } from './application/import-file/historic-modal/historic-modal.component';
import { ImportFileComponent } from './application/import-file/import-file.component';
import { RunScriptElementComponent } from './application/run-script-element/run-script-element.component';
import { RunScriptModalComponent } from './application/run-script-modal/run-script-modal.component';
import { HistoricScriptModalComponent } from './application/run-script/historic-script-modal/historic-script-modal.component';
import { RunScriptComponent } from './application/run-script/run-script.component';
import { TableVisualizationModalComponent } from './application/table-visualization-modal/table-visualization-modal.component';
import { TableVisualizationComponent } from './application/table-visualization/table-visualization.component';
import { ApplicationsAddModalComponent } from './applications/applications-add-modal/applications-add-modal.component';
import { ApplicationsModalComponent } from './applications/applications-modal/applications-modal.component';
import { AudtisComponent } from './audits/audits.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { FormulaireComponent } from './formulaire/formulaire.component';
import { HomecvmComponent } from './homecvm/homecvm.component';
import { HomescriptComponent } from './homescript/homescript.component';
import { HometablesComponent } from './hometables/hometables.component';
import { HomexlsxComponent } from './homexlsx/homexlsx.component';
import { AuthInterceptorService } from './interceptors/AuthInterceptorService';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  imports: [
    AuthModule.forRoot({
      issuer: `${URL.issuer}`,
      redirectUri: `${window.location.origin}`,
      clientId: `${URL.clientId}`,
      scope: 'openid profile',
      postLogoutRedirectUri: `${window.location.origin}/login`,
      bearerAllowedUrls: []
    }),
    SharedModule,
    BrowserAnimationsModule,
    LayoutModule,
    AppRoutingModule,
    AuthenticationComponent,
    ApplicationsModalComponent,
    ApplicationsAddModalComponent,
    ApplicationComponent,
    ImportFileComponent,
    ImportFileModalComponent,
    ConfigurationDbComponent,
    ConfigurationDbModalComponent,
    RunScriptComponent,
    ControllerModalComponent,
    HistoricModalComponent,
    ImportFileXlsxComponent,
    TableVisualizationComponent,
    ImportFileXlsxModalComponent,
    TableVisualizationModalComponent,
    HistoricXlsxModalComponent,
    FormulaireComponent,
    GroupComponent,
    GroupElementComponent,
    GroupModalComponent,
    RunScriptElementComponent,
    HistoricScriptModalComponent,
    RunScriptModalComponent,
    HomecvmComponent,
    HomexlsxComponent,
    HomescriptComponent,
    HometablesComponent,
    AudtisComponent
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe
  ]
})
export class AppModule {}
